const joyfulCareWaves =
  "https://res.cloudinary.com/bacf/image/upload/v1689270037/Era-tek/Hero_Section_kbvuy5.png";
const logo =
  "https://res.cloudinary.com/bacf/image/upload/v1700130820/Era-tek/Eratek_Logo_dyzljq.svg";
const serviceImg1 =
  "https://res.cloudinary.com/bacf/image/upload/v1691068138/Era-tek/service-ops_izzvt9.png";
const serviceImg2 =
  "https://res.cloudinary.com/bacf/image/upload/v1691068265/Era-tek/service-ops-2_xfpzji.png";
const serviceImg3 =
  "https://res.cloudinary.com/bacf/image/upload/v1691068318/Era-tek/service-ops-3_qy6h8t.png";
const serviceImg4 =
  "https://res.cloudinary.com/bacf/image/upload/v1691068388/Era-tek/service-ops-4_srpc6m.png";
const valuePropsImg =
  "https://res.cloudinary.com/bacf/image/upload/v1687262334/Era-tek/Value-Props-Animation-Scroll_nwokdx.png";
const valuePropsBg =
  "https://res.cloudinary.com/bacf/image/upload/v1687262325/Era-tek/background_jwat0k.png";
const uprise =
  "https://res.cloudinary.com/bacf/image/upload/v1689270036/Era-tek/Imag_cover_11_knkxhu.png";
const eraconneckt =
  "https://res.cloudinary.com/bacf/image/upload/v1689270035/Era-tek/Imag_cover_12_we504p.png";
const mariams =
  "https://res.cloudinary.com/bacf/image/upload/v1689270118/Era-tek/Imag_cover_14_r3t52z.png";
const hrtechish =
  "https://res.cloudinary.com/bacf/image/upload/v1720451112/Era-tek/1720450456748_bcnehd.png";
const feedbackImg =
  "https://res.cloudinary.com/bacf/image/upload/v1687262315/Era-tek/feedback-Img_rhhppa.png";
const upriseFeedbackImg =
  "https://res.cloudinary.com/bacf/image/upload/v1694730533/Era-tek/tmp_7187f7dc-63c0-4dd8-ad0f-53a2cc7af7a6_tzdzlm.png";
const lewisDeniseFeedbackImg =
  "https://res.cloudinary.com/bacf/image/upload/v1695393451/Era-tek/1517683401399_concoc.jpg";
const businessPageImage = "https://res.cloudinary.com/bacf/image/upload/v1709132251/Era-tek/tmp_0d0835a8-6e7c-43fb-bffa-5ce5d039c351_huhog3.png";
const eratekInitiatives = "https://res.cloudinary.com/bacf/image/upload/v1709132862/Era-tek/Initiative_1_c2ld2o.png"
const computerBackground = `https://res.cloudinary.com/bacf/image/upload/v1720771173/Era-tek/6e047af7-22e9-4365-ade4-2442e5d26638.png`;
const quote = "https://res.cloudinary.com/bacf/image/upload/v1726093733/HRTechish/Vector_2_s7uaai.png";
const testimonyImg = "https://res.cloudinary.com/bacf/image/upload/v1726092834/HRTechish/Frame_2631_abyqf6.png";
const aboutEratekImage = "https://res.cloudinary.com/bacf/image/upload/v1727044967/Era-tek/Subtract_2_l4u0gp.png";
const beneficiaryImg = "https://res.cloudinary.com/bacf/image/upload/v1727045191/Era-tek/Subtract_3_uzoldo.png";
const hrTech = "https://res.cloudinary.com/bacf/image/upload/v1727044967/Era-tek/Frame_2631_5_j90yrs.png";
const appManagement = "https://res.cloudinary.com/bacf/image/upload/v1727045094/Era-tek/Frame_2631_6_giuhet.png";
const webDev = "https://res.cloudinary.com/bacf/image/upload/v1727044967/Era-tek/Frame_2631_7_jtsknr.png";
const techSupport = "https://res.cloudinary.com/bacf/image/upload/v1727045071/Era-tek/Frame_2631_9_zvgcwd.png";
const projectManagement = "https://res.cloudinary.com/bacf/image/upload/v1727044964/Era-tek/Frame_2631_8_hpvwzr.png";
const digitalSolutions = "https://res.cloudinary.com/bacf/image/upload/v1727044964/Era-tek/Frame_2631_10_g2j1bm.png"
const heroSlider1 = "https://res.cloudinary.com/bacf/image/upload/v1727867888/Era-tek/Property_1_Biz_1_hohenp.svg"
const heroSlider2 = "https://res.cloudinary.com/bacf/image/upload/v1727868469/Era-tek/Property_1_Biz_2_qjmpck.svg"
const heroSlider3 = "https://res.cloudinary.com/bacf/image/upload/v1727868149/Era-tek/Property_1_Biz_3_wnugro.svg"
const eratekLogoColored = "https://res.cloudinary.com/bacf/image/upload/v1727199714/Era-tek/Era-tek-logo-colored_ajk5ve.svg";










export const useExternalMedia = () => {
  return {
    joyfulCareWaves,
    logo,
    serviceImg1,
    serviceImg2,
    serviceImg3,
    serviceImg4,
    valuePropsImg,
    valuePropsBg,
    uprise,
    eraconneckt,
    mariams,
    hrtechish,
    feedbackImg,
    upriseFeedbackImg,
    lewisDeniseFeedbackImg,
    businessPageImage,
    eratekInitiatives,
    computerBackground,
    quote,
    testimonyImg,
    aboutEratekImage,
    beneficiaryImg,
    hrTech,
    appManagement,
    webDev,
    techSupport,
    projectManagement,
    digitalSolutions,
    heroSlider1,
    heroSlider2,
    heroSlider3,
    eratekLogoColored,
  };
};
